import React from 'react';
import PropTypes from 'prop-types';
import replaceCssClasses from '@src/js/Style';
import Button from '../Designer/Button';
import Editor from '../Designer/Editor';
import OfferLinkEditor from './OfferLinkEditor';

export default class OfferLink extends React.Component {

    constructor(props) {

        super(props);

        this.components = {
            button: null,
            editor: null,
        };
    }

    static get propTypes() {

        return {
            context: PropTypes.object.isRequired,
        };
    }

    render() {

        return (
            <>
                <div ref={ (ref) => this.updateComponent('button', ref) } className={ replaceCssClasses('w-full') } onClick={ () => this.onClick() } >
                    <Button
                        i18n='aggregation.offer.title'
                        className='w-full'
                    />
                </div>
                { this.renderEditor() }
            </>
        );
    }

    renderEditor() {

        if (this.props?.context?.storages == undefined)
            return null;

        return <OfferLinkEditor
            ref={ (ref) => this.updateComponent('link', ref) }
            context={ this.props.context }
        />;
    }

    async onClick() {

        if (this.isLocked)
            return;


        if (Editor.isEditMode()) {

            // admin click

            if (this.components.link)
                this.components.link.showEditor();

        }
        else {

            // user click

            this.lockButton();

            await this.components.link.click();

            this.unlockButton();
        }
    }

    get isLocked() {

        return !this.components.button || this.components.button.classList.contains(replaceCssClasses('pulse'));
    }

    lockButton() {

        const classList = this.components.button?.classList;
        if (classList) {

            classList.add(replaceCssClasses('pulse'));
            classList.add(replaceCssClasses('cursor-progress'));
        }
    }

    unlockButton() {

        const classList = this.components.button?.classList;
        if (classList) {

            classList.remove(replaceCssClasses('pulse'));
            classList.remove(replaceCssClasses('cursor-progress'));
        }
    }

    updateComponent(component, ref) {

        this.components[component] = ref;
    }

}